<template>
  <el-container>
    <main class="tab__container">
      <h2 class="page__title">
        Биллинг
      </h2>
      <el-tabs v-model="activeTab">
        <el-tab-pane name="otchet" label="Отчет">
          <div class="tab">
            <main class="page_container">
              <el-form style="max-width: 100%; margin-bottom: -20px" inline>
                <el-form-item style="margin-bottom: 10px" label="Период отчета">
                  <el-date-picker
                    v-model="dateRange"
                    :clearable="false"
                    type="daterange"
                    start-placeholder="Дата начала"
                    end-placeholder="Дата окончания"
                    value-format="yyyy.MM.dd"
                    :disabled="loading"
                  />
                </el-form-item>
                <el-form-item label="Юр. лицо" prop="id_org">
                  <select-org 
                     :org-id="id_org"
                      @change="(org) => (id_org = org.id_org)"
                      @clear="() => (id_org = '')"
                     />
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" :loading="loading" @click="updateBilling">
                    Сформировать отчет
                  </el-button>
                </el-form-item>
                <el-form-item>
                  <JsonExcel :fetch="updateBillingExcel" :fields="json_fields">
                    <el-button type="primary" :loading="loading">
                      Скачать отчет
                    </el-button>
                  </JsonExcel>
                </el-form-item>
              </el-form>
              <el-table class="list" :data="billing" :summary-method="getSummaries" show-summary>
                <el-table-column prop="short_name" label="Название камеры">
                  <template slot-scope="scope">
                    <router-link class="link" :to="{ name: 'cameras:edit', params: { id: scope.row.id_camera } }">
                      {{ scope.row.short_name }}
                    </router-link>
                  </template>
                </el-table-column>
                <el-table-column prop="client_name" label="Владелец" />
                <el-table-column prop="org_name" label="Юридическое лицо" />
                <el-table-column prop="archive_depth" label="Квота хранения" align="center" />
                <el-table-column prop="state" label="Статус камеры" align="center">
                  <template slot-scope="{ row }">
                    <camera-status v-if="row.state" :status="row.state" />
                  </template>
                </el-table-column>
                <el-table-column prop="one_time_payment" label="Единовременный платеж" align="center">
                  <template slot-scope="{ row }">{{ row.one_time_payment | formatPrice }} ₽</template>
                </el-table-column>
                <el-table-column prop="sum_payment" label="Сумма абонентской платы" align="center">
                  <template slot-scope="{ row }">{{ row.sum_payment | formatPrice }} ₽</template>
                </el-table-column>
              </el-table>
            </main>
          </div>
        </el-tab-pane>
      </el-tabs>
    </main>
  </el-container>
</template>

<script>
import { ApiService } from "@/api";
import CameraStatus from "@/components/Cameras/components/Camera/features/CameraStatus";
import { formatPrice } from "@/core/helpers/filters";
import SelectOrg from "@/components/Orgs/components/feature/SelectOrg";
import JsonExcel from "vue-json-excel";

export default {
  name: "Billing",
  components: { CameraStatus, SelectOrg, JsonExcel },
  data() {
    const now = new Date();
    const currentMonth = now.getMonth() + 1 >= 10 ? now.getMonth() + 1 : "0" + (now.getMonth() + 1);
    now.setMonth(+now.getMonth() + 1);
    now.setDate(0);
    const endDate = now.getDate();

    return {
      activeTab: "otchet",
      dateRange: [`${now.getFullYear()}.${currentMonth}.01`, `${now.getFullYear()}.${currentMonth}.${endDate}`],
      billing: [],
      loading: false,
      id_org: '',
      json_fields: {"№": "num",
                   "Наименование активного оборудования": "short_name",
                   "Срок хранения архива": "tariff_name",
                   "Количество дней пользования в отчетном периоде": "countday",
                   "Стоимость тарифного плана руб./в день": "payday",
                   "Итого, рублей": "sum"
                   },
    };
  },
  
  created() {
    this.updateBilling();
  },
  methods: {
    updateBilling() {
      this.loading = true;
      ApiService.billing
        .get(...this.dateRange, this.id_org)
        .then((billing) => {
          this.billing = billing;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async updateBillingExcel() {
      let jsonBillingExcel;
      await ApiService.billing
        .getExcel(...this.dateRange, this.id_org)
        .then((billingExcel) => {
          jsonBillingExcel = billingExcel;
        });
      return jsonBillingExcel;
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];

      sums[0] = "Итоговая сумма:";
      sums[columns.length - 1] =
        formatPrice((data.reduce((sum, billing) => (sum += billing.sum_payment + billing.one_time_payment), 0)).toFixed(2)) + " ₽";

      return sums;
    },
  },
};
</script>

<style>
.list {
  margin: 20px 0;
}
</style>
